import { useQuery } from '@tanstack/react-query';
import { COMMERCIAL_STATUS_LABELS } from '@raro/domain';
import { Glyph, Button, EmptyState, Label, StatusDot, Tag, Title, Figure } from '@raro/ui';
import { Link } from 'react-router';
import { api } from '../../lib/api';
import type { OrganizationFull } from '../../lib/types';

export function ClientesPage() {
  const orgs = useQuery({ queryKey: ['organizations'], queryFn: () => api.get<OrganizationFull[]>('/organizations') });
  const clients = (orgs.data ?? []).filter((o) => !o.isHome);
  return (
    <div className="rr-page rr-stack rr-stack--7">
      <header className="rr-row rr-row--between">
        <div className="rr-stack rr-stack--2"><Glyph name="clientes" size={64} className="rr-page-glyph" /><Label>Clientes</Label><Title>marcas fora do comum.</Title></div>
        <Link to="/organizacoes/nova"><Button variant="primary">novo cliente</Button></Link>
      </header>
      {orgs.isSuccess && clients.length === 0 && <EmptyState title="nenhum cliente ainda." />}
      <div className="rr-client-cards">
        {clients.map((o) => (
          <Link key={o.id} to={`/clientes/${o.id}`} className="rr-card rr-card--link rr-card--cover rr-stack">
            <Figure src={o.cover?.thumbUrl ?? o.cover?.url} ratio="4 / 3" radius="none"><span className="rr-display" style={{ fontSize: 'var(--rr-text-2xl)', fontFamily: 'var(--rr-font-serif)' }}>{o.name}</span></Figure>
            <div className="rr-card__body">
            <div><div className="rr-project-card__org">{o.name.toUpperCase()}</div><div className="rr-project-card__name">{o.tagline ?? o.segment ?? '—'}</div></div>
            <div className="rr-row rr-row--between" style={{ marginTop: 'auto' }}>
              <span className="rr-row" style={{ fontSize: 'var(--rr-text-xs)', color: 'var(--rr-text-2)' }}><StatusDot tone={o.commercialStatus === 'ver' || o.commercialStatus === 'live' || o.commercialStatus === 'fazer' || o.commercialStatus === 'continuous' ? 'active' : 'hollow'} />{COMMERCIAL_STATUS_LABELS[o.commercialStatus ?? 'prospect']}</span>
              {o.city && <Tag tone="outline">{o.city}</Tag>}
            </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
